import React, { useState, useEffect } from 'react';
import useStyles from './styles';
import {
    IRequestData,
    IHorizon,
    IFilterHorizons,
} from '../../../types';
import { AuthContext } from '../../../contexts/Auth/AuthContext';
import apiService from '../../../services/apiService';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';

interface IHorizonProps {
    examId: string | undefined
    horizon: IHorizon
    horizonFilters: IFilterHorizons
    renewHorizon: (data: Array<IHorizon> | undefined) => void
}

export default function HorizonStickinessItem(props: IHorizonProps) {
    const styles = useStyles();
    const auth = React.useContext(AuthContext);
    const [stickiness, setStickiness] = useState<string>('0');

    const [stickinessUpdate, setStickinessUpdate] = useState<boolean>(false);

    async function updateHorizon() {
        if (auth !== undefined && props.examId !== undefined && props.horizon !== undefined) {
            let request_data: IRequestData = {
                horizon_id: props.horizon.id,
                exam_id: parseInt(props.examId),
            };

            if (
                stickiness !== null &&
                stickiness !== '0' &&
                props.horizon.stickiness !== `${stickiness}`
            ) {
                request_data['stickiness'] = `${stickiness}`;
            }

            try {
                await apiService.put(
                    'exams/horizon',
                    request_data
                ).then((response) => {
                    if (response !== undefined && response.status === 200) {
                        props.renewHorizon(response.data.data as Array<IHorizon>);
                    }
                }).catch(() => {
                });
            } catch (e) {
            }
        }
    }

    useEffect(() => {
        if (stickinessUpdate === true) {
            updateHorizon();
            setStickinessUpdate(false);
        }
        return () => setStickinessUpdate(false);
        // eslint-disable-next-line
    }, [stickinessUpdate]);

    useEffect(() => {
        if (props.horizon !== undefined) {
            setStickiness((props.horizon.stickiness === null ? '0' : props.horizon.stickiness));
        }
        // eslint-disable-next-line
    }, [props]);

    return (
        <Grid 
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            key={`${props.horizon.id}${props.horizon.name}stickiness`}
            className={styles.view_horizon_stickiness}
        >
            <Grid item xs={12} className={styles.view_horizon_stickiness_title}>
                <Typography className={styles.text_horizon_stickiness}>
                    <strong>{props.horizon.name}</strong>
                </Typography>
            </Grid>
            <Grid item xs={12} className={styles.view_horizon_stickiness_subtitle}>
                <TextField
                    className={styles.picker_select_type}
                    select
                    value={stickiness ? stickiness : "0"}
                    defaultValue={'0'}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setStickiness(`${event.target.value}`);
                        setStickinessUpdate(true);
                    }}
                >
                    <MenuItem className={styles.picker_select_item} key={'0'} value={'0'}>Selecione</MenuItem>
                    {props.horizonFilters.stickiness.map((element, key) => (
                        <MenuItem className={styles.picker_select_item} key={key} value={`${key + 1}`}>{`${element}`}</MenuItem>
                    ))}
                </TextField>
            </Grid>
        </Grid>
    );
}